import { Box, Button, Stack, styled, Typography } from '@mui/material';
export const CheckWrapper = styled(Stack)(({ theme }) => ({
    height: '100%',
    width: '100%',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: theme.breakpoints.values.xl,
        padding: theme.spacing(0, 10),
        gap: theme.spacing(10),
    },
}));
export const StepContainer = styled(Stack)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
        gap: theme.spacing(6),
        padding: theme.spacing(10, 0),
        flexBasis: '65%',
        flexGrow: 0,
        flexShrink: 1,
        minWidth: 0,
    },
}));
export const StepContent = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(0, 4),
    marginBottom: theme.spacing(44),
    gap: theme.spacing(4),
    width: '100%',
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
        padding: 0,
        gap: theme.spacing(6),
        marginBottom: theme.spacing(6),
        border: '0px',
        overflow: 'visible',
    },
}));
export const MobileLogo = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    lineHeight: 0,
    transform: 'scale(0.8)',
    margin: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));
export const StepTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    fontVariant: 'body1',
    fontWeight: 'bold',
    lineHeight: theme.spacing(4.5),
    fontSize: theme.spacing(3.5),
    textAlign: 'center',
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        fontSize: theme.spacing(4),
        textAlign: 'left',
        paddingBottom: theme.spacing(4),
    },
}));
export const StepHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    fontVariant: 'subtitle1',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    lineHeight: theme.spacing(5),
    fontSize: theme.spacing(4),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
        fontSize: theme.spacing(6),
        textAlign: 'left',
    },
}));
export const DeviceCheckerContainer = styled(Box)(({ theme }) => ({
    aspectRatio: '1',
    [theme.breakpoints.up('md')]: {
        aspectRatio: '16 / 9',
        flex: 0,
    },
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.spacing(4),
}));
export const DeviceCheckConfirmation = styled(Stack)(({ theme }) => ({
    zIndex: theme.zIndex.fab,
    position: 'fixed',
    bottom: theme.spacing(16),
    flexDirection: 'column-reverse',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: theme.spacing(24.5),
    width: '100%',
    padding: theme.spacing(0, 4),
    backgroundColor: `#FAF9F9`, // this colour is not available in design system
    boxShadow: '0px -5px 5px -5px rgba(0, 0, 0, 0.4)',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
        zIndex: 'auto',
        position: 'relative',
        bottom: 'auto',
        flexDirection: 'row',
        justifyContent: 'center',
        height: '100%',
        padding: theme.spacing(0),
        backgroundColor: 'transparent',
        boxShadow: 'none',
        gap: theme.spacing(8),
    },
}));
export const DeviceCheckConfirmationButton = styled(Button)(({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('md')]: {
        maxWidth: theme.spacing(75),
    },
}));
export const Sidebar = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%', // Full width on mobile
    minWidth: 'auto', // Auto min-width on mobile
    padding: theme.spacing(6, 4),
    gap: theme.spacing(3),
    backgroundColor: `#FAF9F9`, // this colour is not available in design system
    flexGrow: 1,
    overflow: 'visible',
    position: 'fixed',
    bottom: 0,
    height: theme.spacing(16),
    [theme.breakpoints.up('md')]: {
        flex: '1 1 0%',
        position: 'relative',
        justifyContent: 'center',
        height: '100%',
        maxWidth: '20rem',
        padding: theme.spacing(0),
        backgroundColor: 'transparent',
    },
}));
export const Logo = styled(Box)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        marginBottom: theme.spacing(6),
    },
}));
export const SidebarContent = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    width: '100%',
    maxWidth: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('md')]: {
        width: theme.spacing(75),
        lineHeight: theme.spacing(4.5),
        fontSize: theme.spacing(3.5),
    },
}));
//# sourceMappingURL=data:application/json;base64,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